<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      :label-col="{ style: { width: '100px' } }"
      :wrapper-col="{ style: { width: '300px' } }"
      :model="formState"
      ref="formRef"
      :rules="rules"
    >
      <a-form-item label="生产日期" name="produceDate">
        <a-date-picker
          v-model:value="formState.produceDate"
          placeholder="请选择生产日期"
          @change="handleSelectDate($event, 'produceDate')"
          :disabled="isEdit"
          allowClear
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="产品名称" name="productName">
        <!-- <a-input
          v-model:value="formState.productName"
          placeholder="请输入产品名称"
          allowClear
          disabled
        ></a-input> -->
        <a-select
          :options="productOption"
          v-model:value="formState.productName"
          placeholder="请选择产品名称"
          :disabled="isEdit"
          @change="handleSelectProduct"
          allowClear
        ></a-select>
      </a-form-item>

      <a-form-item label="型号规格" name="modelSpecifications">
        <template
          v-if="formState.productName && formState.productName !== 'fqc'"
        >
          <a-select
            v-model:value="formState.modelSpecifications"
            :options="defaultModel"
            placeholder="请输入型号规格"
            :disabled="isEdit"
            allowClear
          >
          </a-select>
        </template>

        <template v-else-if="formState.productName === 'fqc'">
          <a-cascader
            v-model:value="modelSpecifications"
            :options="modelSpecificationsOption"
            placeholder="请输入型号规格"
            :disabled="isEdit"
            allowClear
            @change="handleSelectModelSpecificationsOption"
          >
          </a-cascader>
        </template>
      </a-form-item>
      <a-form-item label="生产批号" name="batchNumber">
        <a-input
          v-model:value="formState.batchNumber"
          placeholder="请输入生产批号 例BCP240311A"
          :disabled="isEdit"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="数量" name="number">
        <a-input-number
          v-model:value="formState.number"
          placeholder="请输入数量"
          @change="handleCountChange"
          :disabled="isEdit"
          allowClear
          style="width: 370px"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="产品编号" name="productNumberList">
        <template v-if="formState.batchNumber">
          <select-serial
            :requestConfig="{
              type: formState.productName,
              num: formState.number,
              batchNumber: formState.batchNumber,
            }"
            :productNumberList="formState.productNumberList"
            @selectProductNumberList="selectProductNumberList"
            :disabled="isEdit"
          >
          </select-serial>
        </template>
      </a-form-item>

      <!-- <a-form-item label="单位" name="unit">
        <a-input
          v-model:value="formState.unit"
          placeholder="请输入单位"
          allowClear
        ></a-input>
      </a-form-item>
      <a-form-item label="表单编号" name="formNumber">
        <a-input
          v-model:value="formState.formNumber"
          placeholder="请输入表单编号"
          allowClear
        ></a-input>
      </a-form-item>
      <a-form-item label="版本号" name="edition">
        <a-input
          v-model:value="formState.edition"
          placeholder="请输入版本号"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="编制人" name="writer">
        <a-input
          v-model:value="formState.writer"
          placeholder="请输入编制人"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="编制日期" name="writeDate">
        <a-date-picker
          
          v-model:value="formState.writeDate"
          @change="handleSelectDate($event, 'writeDate')"
          placeholder="请选择编制日期"
          allowClear
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="完成时间" name="finishDate">
        <a-date-picker
          
          v-model:value="formState.finishDate"
          @change="handleSelectDate($event, 'finishDate')"
          placeholder="请选择完成时间"
          allowClear
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="审核人" name="reviewer">
        <a-input
          v-model:value="formState.reviewer"
          placeholder="请输入审核人"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="审核日期" name="reviewDate">
        <a-date-picker
          
          v-model:value="formState.reviewDate"
          @change="handleSelectDate($event, 'reviewDate')"
          placeholder="请选择审核日期"
          allowClear
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="批准人" name="approver">
        <a-input
          v-model:value="formState.approver"
          placeholder="批准人"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="批准时间" name="approveDate">
        <a-date-picker
          
          v-model:value="formState.approveDate"
          @change="handleSelectDate($event, 'approveDate')"
          placeholder="请选择批准时间"
          allowClear
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="核对人" name="checked">
        <a-input
          v-model:value="formState.checked"
          placeholder="核对人"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="核对时间" name="checkedDate">
        <a-date-picker
          
          v-model:value="formState.checkedDate"
          @change="handleSelectDate($event, 'checkedDate')"
          placeholder="请选择核对时间"
          allowClear
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="发料人" name="goodsIssue">
        <a-input
          v-model:value="formState.goodsIssue"
          placeholder="请输入发料人"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="发料时间" name="goodsIssueDate">
        <a-date-picker
          
          v-model:value="formState.goodsIssueDate"
          @change="handleSelectDate($event, 'goodsIssueDate')"
          placeholder="请选发料时间"
          allowClear
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="领料人" name="picker">
        <a-input
          v-model:value="formState.picker"
          placeholder="请输入领料人"
          allowClear
        ></a-input>
      </a-form-item>

      <a-form-item label="领料时间" name="pickDate">
        <a-date-picker
          
          v-model:value="formState.pickDate"
          @change="handleSelectDate($event, 'pickDate')"
          placeholder="请选择领料时间"
          allowClear
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="用途" name="purpose">
        <a-input
          v-model:value="formState.applications"
          placeholder="请输入用途"
          allowClear
        ></a-input>
      </a-form-item> -->
    </a-form>
  </a-modal>
</template>
   
<script>
import { computed, defineComponent, reactive, ref } from "vue";
import selectSerial from "@/views/productDaily/components/instruction/compnents/selectSerial.vue";
import { productOption } from "@/views/productDaily/components/instruction/option";
import {
  insertProductionInstruction,
  updateProductionInstruction,
} from "@/request/view/productionInstruction";
import { notice, timeStampToTime, Toast, isValidDate, debounce } from "@/utils";

import { modelSpecificationsOption } from "@/views/productDaily/serve/option";
import {
  defaultModel,
} from "@/views/productDaily/components/instruction/option";
import { validateBatch } from '@/views/productDaily/components/instruction/validate';

export default defineComponent({
  props: {
    produceOrTpc: String,
  },
  components: {
    selectSerial,
  },
  setup(props, context) {
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const modelSpecifications = ref([]);

    const isEdit = computed(() => modalConfig.type === "update");

    const formState = reactive({
      applications: null,
      approveDate: null,
      approver: null,
      batchNumber: null,
      checked: null,
      checkedDate: null,
      edition: null,
      finishDate: null,
      formNumber: null,
      goodsIssue: null,
      goodsIssueDate: null,
      id: null,
      modelSpecifications: null,
      number: null,
      pickDate: null,
      picker: null,
      produceDate: null,
      produceOrTpc: null,
      productName: null,
      productNumberList: null,
      reviewDate: null,
      reviewer: null,
      unit: null,
      writeDate: null,
      writer: null,
    });

    const showProductNumber = computed(() => {
      let trigger = false;

      if (formState.batchNumber && formState.number && formState.number > 0) {
        trigger = true;
      }

      return trigger;
    });

    // 校验编号
    const validateProductNumberList = async (rule, value) => {
      const list = formState[rule.field];
      if (!list) throw new Error("请输入正确的产品编号");
      const regExpSnNumber = new RegExp(/^BCP2[3-9]\d{4}[A|B|C|D|E|F|G|H|I|J]-\d{3}-\d{3}$/);
      try {
        // 批次号校验
        list.forEach((snNumber) => {
          if (!snNumber) throw new Error("请输入正确的产品编号");
          // 位数校验
          if (snNumber && snNumber.length !== 18)
            throw new Error("请输入正确的产品编号");

          // 批次号校验
          if (snNumber.slice(0, 10) !== formState.batchNumber) {
            throw new Error("产品批号请一致");
          }
          // 格式校验
          if (!regExpSnNumber.test(snNumber)) {
            throw new Error("请输入正确的产品编号");
          }
        });
      } catch (e) {
        return Promise.reject(e);
      }

      return Promise.resolve();
    };

    const rules = {
      produceDate: [
        {
          required: true,
          message: "请选择生产日期",
          trigger: "blur",
          type: "string",
        },
      ],
      batchNumber: [
        {
          required: true,
          whitespace: true,
          validator: validateBatch,
          trigger: "blur",
          type: "string",
        },
      ],
      productName: [
        {
          required: true,
          whitespace: true,
          message: "请输入产品名称",
          trigger: "blur",
          type: "string",
        },
      ],
      modelSpecifications: [
        {
          required: true,
          whitespace: true,
          message: "请输入型号规格",
          trigger: "blur",
          type: "string",
        },
      ],
      // unit: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入单位",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      number: [
        {
          required: true,
          whitespace: true,
          message: "请输入数量",
          trigger: "blur",
          type: "number",
        },
      ],
      productNumberList: [
        {
          required: true,
          trigger: "change",
          validator: validateProductNumberList,
          type: "array",
        },
      ],

      // writeDate: [
      //   {
      //     required: true,
      //     message: "请选择编制日期",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // reviewDate: [
      //   {
      //     required: true,
      //     message: "请选择审核日期",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // finishDate: [
      //   {
      //     required: true,
      //     message: "请选择完成时间",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // approveDate: [
      //   {
      //     required: true,
      //     message: "请选择批准时间",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],

      // formNumber: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入表单编号",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // edition: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入版本号",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // writer: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入编制人",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // reviewer: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入审核人",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // approver: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入批准人",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // checked: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入核对人",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // checkedDate: [
      //   {
      //     required: true,
      //     message: "请选择核对时间",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // goodsIssue: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入发料人",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // goodsIssueDate: [
      //   {
      //     required: true,
      //     message: "请选发料时间",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // picker: [
      //   {
      //     required: true,
      //     whitespace: true,
      //     message: "请输入领料人",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
      // pickDate: [
      //   {
      //     required: true,
      //     message: "请选择领料时间",
      //     trigger: "blur",
      //     type: "string",
      //   },
      // ],
    };

    const formRef = ref();

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      modelSpecifications.value.length = 0;
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.type = null;
      modalConfig.visible = false;
      formRef.value.clearValidate();
    };
    const handleSelectDate = (e, key) => {
      formState[key] = e.format("YYYY-MM-DD");
    };

    // 选择产品
    const handleSelectProduct = (e) => {
      formState.modelSpecifications = null;
      modelSpecifications.value.length = 0;
    };

    let trigger = false;

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then(() => {
          let reqFn =
            modalConfig.type === "insert"
              ? insertProductionInstruction
              : updateProductionInstruction;

          if (trigger) return Toast("warning", "请求中请稍后操作", 3);
          trigger = true;
          reqFn(formState)
            .then((res) => {
              trigger = false;
              const type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);

              if (res.message === '编码重复') return;
              context.emit("updateTable", formState.productName);
              handleCancel();
            })
            .catch((err) => {
              trigger = false;
            });
        })
        .catch((err) => {
          console.log(err);
          if (err.errorFields) {
            const [text] = err.errorFields[0].errors;
            Toast("warning", text, 3);
          }
        });
    });

    const showModal = (option) => {
      const { title, type, data, productName } = option;

      modalConfig.title = title;
      modalConfig.type = type;

      modalConfig.visible = true;

      formState.productName = productName;

      formState.produceOrTpc = props.produceOrTpc;

      if (modalConfig.type === "insert") {
        formState.produceDate = timeStampToTime("", "upload");
      }

      if (modalConfig.type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });

        const modal = modelSpecificationsOption.find((f) => {
          return f.children.find(
            (child) => child.value === formState.modelSpecifications
          );
        });

        if (modal) {
          modelSpecifications.value.push(
            modal.value,
            formState.modelSpecifications
          );
        }
      }

      if (modalConfig.type === "update" && data.pqcList) {
        formState.productNumberList = [];
        data.pqcList.forEach((item) => {
          formState.productNumberList.push(item.snNumber);
        });
      }
    };

    const selectProductNumberList = (list) => {
      formState.productNumberList = list;
    };

    const handleSelectModelSpecificationsOption = (e) => {
      const [machine, modal] = e;

      formState.modelSpecifications = modal ? modal : null;
    };

    return {
      rules,
      isEdit,
      formRef,
      formState,
      modalConfig,
      productOption,
      showProductNumber,
      modelSpecifications,
      modelSpecificationsOption,
      defaultModel,
      handleOk,
      showModal,
      handleCancel,
      handleSelectDate,
      handleSelectProduct,
      selectProductNumberList,
      handleSelectModelSpecificationsOption,
    };
  },
});
</script>
   
<style lang="less" scoped>
:deep(.ant-cascader-picker-disabled) {
  color: #000;
}
</style>